
export default {
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    richTextToHtml(field) {
      return this.$storyapi.richTextResolver.render(field)
    },
  },
}
